import http from "@/common/js/request";

/* 获取日期 */
export const userLogin = (params = {}) => {
    return http({
        url: '/api/auth/login',
        method: 'GET',
        params
    })
}